export let aliyunInstance = 'huidr-ccc'

export let ajaxPath = '/api/aliyun/new/ccc/api'

export let ajaxPathDev = '/aliyun/new/ccc/api'

export let  autoAnswerCall = 999 ; // 有来电振铃响 自动接听 的秒  ----- 要求拒接 ，主动打电话

export let afterCallRule = 0;  // 挂机后的话后处理时间
